console.log("custom js")


// Logout button click clear cart.  
function clearcart(){
  var Logout_button=$('.customer_logout');
  Logout_button.on('click',function(e){
    //e.preventDefault()
    console.log("click")
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {
        //Shopify.clear();
        window.location.href = "/account/logout";
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    return false;
  });
}

clearcart();